import { Component, OnInit, Input } from '@angular/core';
import { Quotes } from '@models/models';
import { SettingsProvider } from '@services/settings/settings';
import { PaymentsServiceProvider } from '@services/payments/payments-service/payments.service';

@Component({
	selector: 'quote-assignment-panel',
	template: require('./quote-assignment-panel.component.html'),
	styles: [require('./quote-assignment-panel.component.scss')]
})
export class QuoteAssignmentPanelComponent implements OnInit {
	@Input('data') data: Quotes;
	@Input() isQuote: boolean;
	@Input('isFixed') isFixed: boolean;

	contractName = 'None';
	questionnaireName = 'None';
	paymentScheduleName = 'No split payments';
	dateFormat: string;
	hidePaymentsSchedule: boolean;

	constructor(
		private settingsService: SettingsProvider,
		private paymentsService: PaymentsServiceProvider
	) {}

	ngOnInit(): void {
		this.setAssignmentNames();
	}

	getDateFormat(): void {
		this.settingsService.timeFormatSettings.subscribe(data => {
			this.dateFormat =
				data.dateFormat === 'DD_MM_YYYY' ? 'DD MMM YYYY' : 'MMM DD YYYY';
		});
	}

	setAssignmentNames(): void {
		const {
			contract,
			questionnaire,
			paymentSchedule,
			paymentsRule,
			summary,
			payments
		} = this.data;
		if (contract !== null) {
			this.contractName = contract.name;
		}
		if (questionnaire !== null) {
			this.questionnaireName = questionnaire.name;
		}
		if (paymentSchedule !== null) {
			this.paymentScheduleName = paymentSchedule.name;
		} else if (paymentsRule) {
			if (paymentsRule.strategy === 'NO_SPLIT_PAYMENTS') {
				this.paymentScheduleName = 'No split payments';
				this.hidePaymentsSchedule =
					!this.isFixed && this.isQuote
						? payments.length === 0
						: !summary || summary.total === 0;
			} else if (paymentsRule.strategy === 'NO_DUE_DATE') {
				this.paymentScheduleName = 'No payment required';
			}
		} else {
			this.paymentScheduleName = 'No split payments';
			this.hidePaymentsSchedule =
				!this.isFixed && this.isQuote
					? payments.length === 0
					: !summary || summary.total === 0;
		}
	}

	constructStatusDueLabel(days: number): string {
		if (days <= -1) {
			return days === -1 ? '(1 day ago)' : `(${-1 * days} days ago)`;
		}
		if (days === 0) {
			return '(today)';
		}
		if (days === 1) {
			return '(in 1 day)';
		}
		return `(in ${days} days)`;
	}

	constructAmountLabel(payment): string {
		if (this.isFixed || this.data.status.toUpperCase() === 'ACCEPTED') {
			return payment.amountWithCurrency.amountWithCurrency;
		} else if (
			this.data.status.toUpperCase() !== 'ACCEPTED' &&
			!this.isFixed &&
			this.data.paymentsRule.strategy !== 'NO_SPLIT_PAYMENTS'
		) {
			if (payment.paymentSchedulePart.type === 'Dollars') {
				return `${payment.amountWithCurrency.currencySymbol}${
					payment.paymentSchedulePart.amount
				}`;
			}
			return `${
				payment.paymentSchedulePart.amount
			}${this.paymentsService.setAmountType(payment.paymentSchedulePart.type)}`;
		} else if (
			this.data.status.toUpperCase() !== 'ACCEPTED' &&
			!this.isFixed &&
			this.data.paymentsRule.strategy === 'NO_SPLIT_PAYMENTS'
		) {
			return '100% of order';
		}
		return '';
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/quote/quote-assignment-panel/quote-assignment-panel.component.ts